// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3W_IG","tab":"Tabs_tab__YxiMN","tabActive":"Tabs_tabActive__2KOyI"};